<a routerLink="/">
  <img src="/assets/job-board/img/rex-logo.svg" alt="Logo">
</a>
